const offers = [
    {
      image: "http://cyberpunk2077-larp.de/images/logos/Samurai_Logo.webp",
      title: 'New event: Trip to Vegas',
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Utenim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      date: '9:32 AM',
      id: "0"
    },
    {
      image: "http://cyberpunk2077-larp.de/images/logos/Maelstrom_Logo.webp",
      title: 'Long time no chat',
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Utenim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      date: '6:12 AM',
      id: "1"
    },
    {
      image: "http://cyberpunk2077-larp.de/images/logos/Tyger_Claw_Logo.webp",
      title: 'Report Results',
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Utenim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      date: '4:55 AM',
      id: "2"
  
    },
    {
      image: "http://cyberpunk2077-larp.de/images/logos/Voodoo_Boys_Logo.webp",
      title: 'The situation',
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Utenim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      date: 'Yesterday',
      id: "3"
    },
    {
      image: "",
      title: 'Updated invitation: Swim lessons',
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Utenim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      date: 'Yesterday',
      id: "4"
    },
    {
      image: "",
      title: 'Last minute ask',
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Utenim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      date: 'Yesterday',
      id: "5"
    },
    {
      image: "",
      title: 'Family Calendar - Version 1',
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Utenim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      date: 'Last Week',
      id: "6"
    },
    {
      image: "",
      title: 'Placeholder Headhots',
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Utenim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      date: 'Last Week',
      id: "7"
    }
  ];
  
  export const getOffers = () => offers;
  